import styled from "../_snowpack/pkg/@emotion/styled.js";
import React from "../_snowpack/pkg/react.js";
import Component from "./editable-component.js";
import {colors, media} from "./theme.js";
import {Title} from "./typo.js";
import {Widget} from "../_snowpack/pkg/@typeform/embed-react.js";
import Doc from "./doc.js";
export default function FormPage(props) {
  const {headline, typeform_id, content} = props;
  return /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(Component, {
    ...props
  }, /* @__PURE__ */ React.createElement(FormTitle, {
    level: 2
  }, headline), content && content?.map((c, key) => c.content && /* @__PURE__ */ React.createElement(DocContainer, {
    key,
    ...c.content
  })), typeform_id && /* @__PURE__ */ React.createElement(TypeFormWidget, {
    id: typeform_id,
    style: {width: "100%", height: "600px"}
  })));
}
const Container = styled.div`
  padding-top: 80px;
  max-width: 970px;
  margin: auto;

  ${media.mobile} {
    padding-top: 32px;
  }
`;
const TypeFormWidget = styled(Widget)`
  margin-top: 35px;
`;
const FormTitle = styled(Title)`
  ${media.mobile} {
    font-size: 30px;
  }
`;
const DocContainer = styled(Doc)`
  padding: 30px 0;

  h1,
  h2 {
    margin-bottom: 1em;
    color: ${colors.b};
  }

  h1 {
    font-size: 24px;
  }

  h2 {
    font-size: 20px;
  }

  b {
    color: ${colors.b};
  }

  p {
    color: ${colors.b2};
    // margin-top: 1em;
    // margin-bottom: 1em;
    min-height: 1em;
  }

  blockquote {
    margin-left: 1.5em;
  }

  ul li {
    list-style: disc;
    margin-left: 1.5em;
  }

  ol li {
    list-style: decimal;
    margin-left: 1.5em;
  }

  ${media.phone} {
    padding-top: 32px;
    padding-bottom: 64px;

    h1 {
      font-size: 20px;
    }

    h2 {
      font-size: 16px;
    }
  }
`;
